import type { QueryProperty, Component, BaseDataItem } from '@wix/thunderbolt-becky-types'
import { removeHash } from '@wix/thunderbolt-catharsis'
import type { Unref } from '@wix/thunderbolt-catharsis'
import { QUERY_MAPPING } from '../constants'
import type { ScopedCreateRef } from '../compNodeUtils'
import type { GetOverrideDataRefs, DataItemWithDependencies, DataItemWithOverridesRefs } from './types'

export const getDataItemRefsWithOverrides = ({
	templateComponent,
	queryName,
	itemSuffix = '',
	createRefInTemplateNamespace,
	getOverrideDataRefs,
	templateDataId = '',
}: {
	templateComponent: Component
	queryName: QueryProperty
	itemSuffix?: string
	createRefInTemplateNamespace: ScopedCreateRef
	getOverrideDataRefs: GetOverrideDataRefs
	templateDataId?: string
}) => [
	...getOverrideDataRefs({
		compId: templateComponent.id,
		queryName,
		itemSuffix,
		templateDataId,
	}),
	templateComponent[queryName] &&
		createRefInTemplateNamespace<BaseDataItem>(
			QUERY_MAPPING[queryName],
			`${templateDataId || removeHash(templateComponent[queryName]!)}${itemSuffix}`
		),
]

export const getOverrideItem = (
	items: Readonly<Array<DataItemWithDependencies | undefined>>
): DataItemWithDependencies => {
	return items.find(Boolean)!
}

// get the most external override (which is the determining one). If non exist, returns the default data item
export const resolveOverrideItem = (
	items: Readonly<Array<DataItemWithDependencies | undefined>>,
	inflatedDataItemId: string
): DataItemWithDependencies => {
	const dataItem = getOverrideItem(items)
	return {
		...dataItem,
		id: inflatedDataItemId,
	}
}

export const defaultRefConsumptionDataNodeToViewItem = (id: string, value: Unref<DataItemWithOverridesRefs>) => {
	const { dataItemWithOverrides } = value
	const dataItem = getOverrideItem(dataItemWithOverrides)
	if (!dataItem) {
		return
	}

	return { ...dataItem, id }
}
